export type OrigemDocumento = "APP_INCLUSAO" | "APP_EXCLUSAO" | "APP_ALTERACAO" | "CAMPANHA" | "CARGA_INICIAL";
export type EstadoDaVersao = "VIGENTE" | "SUBSTITUIDA" | "INVALIDADA";

export interface IDocumentoColaborador {
  id: string;
  origem: OrigemDocumento;
  cpf: string;
  nome: string | null;
  workspaceId: string;
  contrato: string | null; // número do contrato do cadastro; null sem número
  operadora: string | null;
  tipo: string;
  enviadoEm: string;
  baixadoPelaCorretoraEm: string | null;
  baixadoPor: string | null;
  pendenteParaCorretora: boolean;
  versaoVigente: boolean;
  /** Só vem do Cofre (empresa com leitura por natureza); as linhas antigas derivam de versaoVigente. */
  estado?: EstadoDaVersao;
  motivoInvalidacao?: string | null;
}

export interface IDocumentosResposta {
  data: IDocumentoColaborador[];
  campanhasIndisponiveis: boolean;
}

/** Máximo de documentos por .zip (limite do backend). */
export const LIMITE_ZIP = 200;
